var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import iconPayment from "../../assets/img/icons/icon-successful-payment.png";
import { fetchBalance as fetchBalanceAction } from "../../actions/creators/balance";
import { resourceNames } from "../../constants/accountResourceNames";
import { getQueryVariable } from "../../shared/sharedFunctions";
var formatBalance = function (value) {
    return Intl.NumberFormat("ru", { maximumFractionDigits: 2 }).format(value);
};
var formatAmount = function (value) { return Intl.NumberFormat("ru").format(value); };
var RechargeSuccess = /** @class */ (function (_super) {
    __extends(RechargeSuccess, _super);
    function RechargeSuccess() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RechargeSuccess.prototype.componentDidMount = function () {
        this.props.fetchBalanceAction();
    };
    RechargeSuccess.prototype.render = function () {
        var _a = this.props, intl = _a.intl, balance = _a.balance, user = _a.user, location = _a.location;
        var currency = resourceNames[user.accountResourceId] || "UZS";
        var queryAmount = Number(getQueryVariable("amount"));
        var rechargeAmount = (location.state && location.state.amount) ||
            (Number.isFinite(queryAmount) ? queryAmount : null);
        return (_jsxs("div", __assign({ id: "content" }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 \u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0447\u0435\u0442\u0430"] }) }), _jsx("div", __assign({ className: "blc block blc_recharge" }, { children: _jsx("div", __assign({ className: "section" }, { children: _jsx("div", __assign({ className: "new-join__wrapper" }, { children: _jsx("div", __assign({ className: "toggle_content" }, { children: _jsx("div", __assign({ className: "body" }, { children: _jsxs("div", __assign({ className: "successful-payment-message" }, { children: [_jsx("img", { src: iconPayment, alt: "icon" }), rechargeAmount != null ? (_jsx("p", { children: intl.formatMessage({ id: "recharge.expay.status_success" }, { amount: formatAmount(rechargeAmount) }) })) : (_jsx("p", { children: intl.formatMessage({ id: "recharge.success_msg" }) })), balance !== null && balance !== undefined && (_jsx("p", { children: intl.formatMessage({ id: "recharge.success_balance" }, {
                                                    balance: formatBalance(balance),
                                                    currency: currency
                                                }) })), _jsx("div", __assign({ className: "controls" }, { children: _jsx(Link, __assign({ to: "/" }, { children: intl.formatMessage({ id: "recharge.start_game" }) })) }))] })) })) })) })) })) }))] })));
    };
    return RechargeSuccess;
}(React.Component));
var mapStateToProps = function (state) { return ({
    balance: state.balance.value,
    user: state.auth.user
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({ fetchBalanceAction: fetchBalanceAction }, dispatch);
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(RechargeSuccess)));



// WEBPACK FOOTER //
// ./src/components/recharge/Success.jsx